export default __webpack_public_path__ + "static/media/website-pix.34e8782c.png";